import Layout from '../components/Layout'
// import PropTypes from 'prop-types'
import React from 'react'

// const ProcessComponent = ({ process }) => {
//   return (
//     <div className="column is-4">
//       <div className="columns align-items-center">
//         <div className="column mb-half mb-padding-top-less">
//           <img src={'/img/opportunities/' + process.image + '.png'} alt=""></img>
//         </div>

//         <div className="column mb-text-center mb-padding-top-less">
//           <h3 className="is-size-6 border-b-l brand-color">{process.title}</h3>
//           <p className="is-size-7">{process.description}</p>
//         </div>
//       </div>
//     </div>
//   )
// }

export default class OpportunityPage extends React.Component {
  render() {
    // const processes = [
    //   {
    //     title: 'Franchising consultation',
    //     description:
    //       'To set the purpose and direction of the business and look for an outlet adequate to your fund scale and outlet size',
    //     image: 'Step-1',
    //   },
    //   {
    //     title: 'Start-up consultation',
    //     description:
    //       'To estimate the anticipated revenue based on data such as location conditions analysis and competitor research of proposed sites',
    //     image: 'Step-2',
    //   },
    //   {
    //     title: 'Outlet location and franchisee agreement',
    //     description:
    //       'To sign tenancy agreement and franchise agreement, discuss interior design, facilities and appliances',
    //     image: 'Step-4',
    //   },
    //   {
    //     title: 'Outlet Manager and team training',
    //     description:
    //       'To learn the product operation manual and how to operate machinery and equipment and service training through on-job-training in actual outlet',
    //     image: 'Step-4',
    //   },
    //   {
    //     title: 'Agreement and Construction',
    //     description:
    //       'Franchising agreement stamping, completion of construction of the outlet',
    //     image: 'Step-5',
    //   },
    //   {
    //     title: 'Final check',
    //     description:
    //       'Machinery, installations and trial run, food ingredients, inspection, sales practice and final check through HQ supervisor',
    //     image: 'Step-6',
    //   },
    //   {
    //     title: 'Open',
    //     description:
    //       'Opening marketing material support, budget planning for an outlet opening',
    //     image: 'Step-7',
    //   },
    //   {
    //     title: 'Follow-up supervision, Management support',
    //     description: 'Regular visits from the supervisor after opening',
    //     image: 'Step-8',
    //   },
    // ]

    const concepts = [
      {
        imageUrl: 'Space.png',
        text: 'Creative and relaxing space that stimulates creativity',
      },
      {
        imageUrl: 'Time.png',
        text: 'Create moments or stories with good friends',
      },
      {
        imageUrl: 'Experience.png',
        text:
          'Experience the taste, relax, creative space and best service in Caffe Bene',
      },
    ]
    return (
      <Layout>
        <img className="full-w" src="/img/opportunities/banner.jpg" alt="" />

        <div className="has-background-white-bis section">
          <div className="container">
            <div className="has-text-centered">
              <h1 className="title brand-color">Interior Concept</h1>
              <div className="columns pd-tb-2">
                {concepts.map(concept => (
                  <div className="column">
                    <img
                      className="concept-img"
                      src={'/img/opportunities/' + concept.imageUrl}
                      alt=""
                    ></img>
                    <p>{concept.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* Section asked to be removed */}
        {/* <div className="section">
          <div className="container">
            <div className="column">
              <h1 className="has-text-centered title brand-color">Process Of Opening</h1>
              <br/>
              <div className="columns is-multiline mg-top-2">
              {
                processes.map(process => (
                  <ProcessComponent
                    key={process.image}
                    process={process}/>
                ))
              }
              </div>
            </div>
          </div>
        </div> */}
      </Layout>
    )
  }
}
